import { render, staticRenderFns } from "./PmsPlaces.vue?vue&type=template&id=72239f32&scoped=true"
import script from "./PmsPlaces.vue?vue&type=script&lang=js"
export * from "./PmsPlaces.vue?vue&type=script&lang=js"
import style0 from "./PmsPlaces.vue?vue&type=style&index=0&id=72239f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72239f32",
  null
  
)

export default component.exports